var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-charts',_vm._b({ref:"line",staticClass:"w-100",attrs:{"theme":"theme-color","auto-resize":""}},'e-charts',{
    autoresize: true,
    options: _vm.options,
    source: _vm.source,
    responsive: true,
  },false))}
var staticRenderFns = []

export { render, staticRenderFns }